import { c as _c } from "react/compiler-runtime";
import { Typography, type TypographyProps } from '@mui/material';
import type { PropsWithChildren } from 'react';
export function ContentText(t0) {
  const $ = _c(7);
  let additionalProps;
  let children;
  if ($[0] !== t0) {
    ({
      children,
      ...additionalProps
    } = t0);
    $[0] = t0;
    $[1] = additionalProps;
    $[2] = children;
  } else {
    additionalProps = $[1];
    children = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      xs: "0.75rem",
      md: "1rem"
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = children || "-";
  let t3;
  if ($[4] !== additionalProps || $[5] !== t2) {
    t3 = <Typography fontSize={t1} {...additionalProps}>{t2}</Typography>;
    $[4] = additionalProps;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}